import { Text } from '@audio-network/componentlibrary'
import { Sparkle } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'

import styles from './AiSearchComponent.module.css'
import { AiSearchComponentProps } from './AiSearchComponent.types'

const AiSearchComponent = ({
	prompt,
	showExplanation,
}: AiSearchComponentProps): JSX.Element => {
	const { t } = useTranslation(['search'])
	return (
		<div className={styles.aiSearch}>
			<div className={styles.aiSearchTryAi}>
				<div className={styles.aiSearchTryAiIcon}>
					<Sparkle
						color="electricBlue"
						className={styles.aiSearchTryAiIconSparkle}
					/>
				</div>
				<div className={styles.aiSearchTryAiTextContainer}>
					<Text bold className={styles.aiSearchTryAiText}>
						{t('try-prompt-search')}:
					</Text>
					<Text className={styles.aiSearchPrompt}>{prompt}</Text>
				</div>
			</div>
			<div className={styles.aiSearchTryAiSeparator} />
			{showExplanation && (
				<div className={styles.aiSearchExplanation}>
					<Text bold display="block">
						{t('what-is-prompt-search')}
					</Text>
					<Text>{t('what-is-prompt-search-description')}</Text>
				</div>
			)}
		</div>
	)
}

export default AiSearchComponent
